export function redirect(apiKey: string, redirectUrl: string): Promise<boolean> {
  return fetch(`https://ipgeolocation.abstractapi.com/v1/?api_key=${apiKey}&fields=country_code`)
    .then(res => res.json())
    .then(countryObj => countryObj.country_code === 'RU')
    .then(isRedirect => {
      if (isRedirect) {
        document.location.replace(redirectUrl);
      }
      return isRedirect;
    })
    .catch(err => false);
}
